


// import React, { useEffect, useMemo, useState } from "react";
// import { useAuth } from "../App";
// import Layout from "../components/Layout";
// import {
//   Card,
//   CardHeader,
//   CardTitle,
//   CardContent,
// } from "../components/ui/card";
// import { toast } from "sonner";
// import {
//   CalendarDays,
//   Clock,
//   CheckCircle2,
//   AlertCircle,
//   Users,
//   RefreshCw,
//   ChevronRight,
// } from "lucide-react";

// /* =========================================================
//    OUTILS
// ========================================================= */

// function getPrestationsArray(data) {
//   if (Array.isArray(data)) return data;

//   if (Array.isArray(data?.prestations)) {
//     return data.prestations;
//   }

//   if (Array.isArray(data?.items)) {
//     return data.items;
//   }

//   if (Array.isArray(data?.data)) {
//     return data.data;
//   }

//   if (Array.isArray(data?.results)) {
//     return data.results;
//   }

//   return [];
// }

// function getId(item) {
//   return item?.id || item?._id;
// }

// function getStartDate(prestation) {
//   return (
//     prestation?.dateStart ||
//     prestation?.date_start ||
//     prestation?.startDate ||
//     prestation?.start_date ||
//     prestation?.date ||
//     prestation?.start ||
//     null
//   );
// }

// function getEndDate(prestation) {
//   return (
//     prestation?.dateEnd ||
//     prestation?.date_end ||
//     prestation?.endDate ||
//     prestation?.end_date ||
//     prestation?.end ||
//     null
//   );
// }

// function parseDate(value) {
//   if (!value) return null;

//   const date = new Date(value);

//   if (Number.isNaN(date.getTime())) {
//     return null;
//   }

//   return date;
// }

// function startOfDay(date) {
//   const d = new Date(date);
//   d.setHours(0, 0, 0, 0);
//   return d;
// }

// function endOfDay(date) {
//   const d = new Date(date);
//   d.setHours(23, 59, 59, 999);
//   return d;
// }

// function addDays(date, numberOfDays) {
//   const d = new Date(date);
//   d.setDate(d.getDate() + numberOfDays);
//   return d;
// }

// function isSameDay(date1, date2) {
//   if (!date1 || !date2) return false;

//   return (
//     date1.getFullYear() === date2.getFullYear() &&
//     date1.getMonth() === date2.getMonth() &&
//     date1.getDate() === date2.getDate()
//   );
// }

// /*
//  * Une prestation appartient à aujourd'hui si :
//  *
//  * - elle commence aujourd'hui
//  * OU
//  * - elle a commencé avant aujourd'hui et se termine aujourd'hui
//  * OU
//  * - elle couvre toute la journée actuelle.
//  */
// function isToday(prestation) {
//   const start = parseDate(getStartDate(prestation));
//   const end = parseDate(getEndDate(prestation));

//   if (!start) return false;

//   const today = new Date();

//   if (isSameDay(start, today)) {
//     return true;
//   }

//   if (
//     end &&
//     start <= endOfDay(today) &&
//     end >= startOfDay(today)
//   ) {
//     return true;
//   }

//   return false;
// }

// /*
//  * Retourne true si la prestation commence entre demain
//  * et J+3 inclus.
//  *
//  * IMPORTANT :
//  * On ne montre donc PAS toutes les prestations futures.
//  */
// function isWithinNextThreeDays(prestation) {
//   const start = parseDate(getStartDate(prestation));
//   const end = parseDate(getEndDate(prestation));

//   if (!start) return false;

//   const today = new Date();

//   const tomorrowStart = startOfDay(addDays(today, 1));
//   const threeDaysEnd = endOfDay(addDays(today, 3));

//   /*
//    * Cas normal :
//    * la prestation commence entre demain et J+3.
//    */
//   if (
//     start >= tomorrowStart &&
//     start <= threeDaysEnd
//   ) {
//     return true;
//   }

//   /*
//    * Cas d'une prestation qui a commencé avant demain
//    * mais qui continue sur une des 3 journées à venir.
//    */
//   if (
//     end &&
//     start < tomorrowStart &&
//     end >= tomorrowStart &&
//     start <= threeDaysEnd
//   ) {
//     return true;
//   }

//   return false;
// }

// /*
//  * Vérifie si la prestation est réellement future.
//  */
// function isFuture(prestation) {
//   const start = parseDate(getStartDate(prestation));

//   if (!start) return false;

//   return start > new Date();
// }

// function formatDate(value) {
//   const date = parseDate(value);

//   if (!date) return "-";

//   return date.toLocaleDateString("fr-BE", {
//     day: "2-digit",
//     month: "2-digit",
//     year: "numeric",
//   });
// }

// function formatDayName(date) {
//   if (!date) return "";

//   return date.toLocaleDateString("fr-BE", {
//     weekday: "long",
//   });
// }

// function formatShortDate(date) {
//   if (!date) return "";

//   return date.toLocaleDateString("fr-BE", {
//     day: "2-digit",
//     month: "2-digit",
//   });
// }

// function formatTime(value) {
//   const date = parseDate(value);

//   if (!date) return "-";

//   return date.toLocaleTimeString("fr-BE", {
//     hour: "2-digit",
//     minute: "2-digit",
//   });
// }

// function getInstitutionName(prestation) {
//   return (
//     prestation?.institution_name ||
//     prestation?.institutionName ||
//     prestation?.institution?.name ||
//     prestation?.institution?.institution_name ||
//     prestation?.institution ||
//     "-"
//   );
// }

// function getSoignantType(prestation) {
//   return (
//     prestation?.type_soignant ||
//     prestation?.typeSoignant ||
//     prestation?.soignant_type ||
//     prestation?.soignantType ||
//     prestation?.role ||
//     ""
//   );
// }

// function getAssignedName(prestation) {
//   return (
//     prestation?.assigned_name ||
//     prestation?.assignedName ||
//     prestation?.soignant_name ||
//     prestation?.soignantName ||
//     prestation?.assigned_to_name ||
//     prestation?.assignedToName ||
//     null
//   );
// }

// function getStatus(prestation) {
//   return (
//     prestation?.status ||
//     prestation?.state ||
//     prestation?.statut ||
//     ""
//   )
//     .toString()
//     .toLowerCase()
//     .trim();
// }

// function isPending(prestation) {
//   const status = getStatus(prestation);

//   return (
//     status === "pending" ||
//     status === "en_attente" ||
//     status === "en attente" ||
//     status === "waiting" ||
//     status === "requested" ||
//     status === "request"
//   );
// }

// function getPrestataireLabel(type) {
//   if (!type) return "Soignant";

//   const value = type.toString().toLowerCase();

//   if (
//     value.includes("nurse") ||
//     value.includes("infirm") ||
//     value === "infirmier" ||
//     value === "infirmière"
//   ) {
//     return "Infirmier";
//   }

//   if (
//     value.includes("caregiver") ||
//     value.includes("aide") ||
//     value.includes("soignant") ||
//     value === "as"
//   ) {
//     return "Aide-soignant";
//   }

//   return type;
// }

// /* =========================================================
//    BADGE STATUT
// ========================================================= */

// function StatusBadge({ prestation }) {
//   const assignedName = getAssignedName(prestation);
//   const pending = isPending(prestation);

//   if (pending) {
//     return (
//       <span className="inline-flex items-center gap-1.5 rounded-full bg-amber-100 px-3 py-1 text-xs font-semibold text-amber-800">
//         <AlertCircle size={13} />
//         En attente
//       </span>
//     );
//   }

//   if (assignedName) {
//     return (
//       <span className="inline-flex items-center gap-1.5 rounded-full bg-emerald-100 px-3 py-1 text-xs font-semibold text-emerald-800">
//         <CheckCircle2 size={13} />
//         Assignée
//       </span>
//     );
//   }

//   return (
//     <span className="inline-flex items-center gap-1.5 rounded-full bg-muted px-3 py-1 text-xs font-semibold text-muted-foreground">
//       Disponible
//     </span>
//   );
// }

// /* =========================================================
//    CARTE STATISTIQUE
// ========================================================= */

// function StatCard({
//   icon: Icon,
//   title,
//   value,
//   description,
// }) {
//   return (
//     <Card className="glass-card border-border">
//       <CardContent className="p-5">
//         <div className="flex items-start justify-between gap-4">
//           <div>
//             <p className="text-sm font-medium text-muted-foreground">
//               {title}
//             </p>

//             <p className="mt-2 text-3xl font-bold tracking-tight">
//               {value}
//             </p>

//             <p className="mt-1 text-xs text-muted-foreground">
//               {description}
//             </p>
//           </div>

//           <div className="rounded-xl bg-primary/10 p-3 text-primary">
//             <Icon size={22} />
//           </div>
//         </div>
//       </CardContent>
//     </Card>
//   );
// }

// /* =========================================================
//    LIGNE PRESTATION
// ========================================================= */

// function PrestationRow({
//   prestation,
//   users,
//   assigned,
//   setAssigned,
//   approvePrestation,
//   approvingId,
//   showDate = true,
// }) {
//   const id = getId(prestation);

//   const start = getStartDate(prestation);
//   const end = getEndDate(prestation);

//   const type = getSoignantType(prestation);

//   const matchingUsers = users.filter((user) => {
//     if (!type) return true;

//     const wanted = type.toString().toLowerCase();
//     const role = (user.role || "").toString().toLowerCase();

//     if (wanted === role) {
//       return true;
//     }

//     if (
//       wanted.includes("nurse") ||
//       wanted.includes("infirm")
//     ) {
//       return (
//         role.includes("nurse") ||
//         role.includes("infirm")
//       );
//     }

//     if (
//       wanted.includes("caregiver") ||
//       wanted.includes("aide") ||
//       wanted.includes("soignant") ||
//       wanted === "as"
//     ) {
//       return (
//         role.includes("caregiver") ||
//         role.includes("aide") ||
//         role === "as" ||
//         role.includes("soignant")
//       );
//     }

//     return false;
//   });

//   return (
//     <tr className="border-t border-border/70 transition-colors hover:bg-muted/40">
//       {/* PRESTATION */}
//       <td className="px-4 py-4 align-top">
//         <div className="font-semibold">
//           {prestation?.name ||
//             prestation?.title ||
//             "Prestation"}
//         </div>

//         {prestation?.description && (
//           <div className="mt-1 max-w-xs text-xs text-muted-foreground line-clamp-2">
//             {prestation.description}
//           </div>
//         )}
//       </td>

//       {/* INSTITUTION */}
//       <td className="px-4 py-4 align-top">
//         <div className="font-medium">
//           {getInstitutionName(prestation)}
//         </div>
//       </td>

//       {/* DATE */}
//       {showDate && (
//         <td className="px-4 py-4 align-top">
//           <div className="flex items-center gap-2">
//             <CalendarDays
//               size={15}
//               className="text-primary"
//             />

//             <span>
//               {formatDate(start)}
//             </span>
//           </div>

//           <div className="mt-1 flex items-center gap-2 text-xs text-muted-foreground">
//             <Clock size={13} />

//             <span>
//               {formatTime(start)}

//               {end
//                 ? ` → ${formatTime(end)}`
//                 : ""}
//             </span>
//           </div>
//         </td>
//       )}

//       {/* TYPE */}
//       <td className="px-4 py-4 align-top">
//         <div className="flex flex-col gap-2">
//           <span className="text-sm font-medium">
//             {getPrestataireLabel(type)}
//           </span>

//           <StatusBadge prestation={prestation} />
//         </div>
//       </td>

//       {/* SOIGNANT */}
//       <td className="px-4 py-4 align-top">
//         {getAssignedName(prestation) ? (
//           <div className="flex items-center gap-2 text-sm">
//             <Users
//               size={15}
//               className="text-muted-foreground"
//             />

//             <span>
//               {getAssignedName(prestation)}
//             </span>
//           </div>
//         ) : (
//           <select
//             value={assigned[id] || ""}
//             onChange={(e) =>
//               setAssigned((prev) => ({
//                 ...prev,
//                 [id]: e.target.value,
//               }))
//             }
//             className="w-full min-w-[210px] rounded-lg border border-border bg-background px-3 py-2 text-sm outline-none transition focus:ring-2 focus:ring-primary/30"
//           >
//             <option value="">
//               -- Choisir un soignant --
//             </option>

//             {matchingUsers.length === 0 ? (
//               <option value="" disabled>
//                 Aucun utilisateur compatible
//               </option>
//             ) : (
//               matchingUsers.map((user) => (
//                 <option
//                   key={user.id}
//                   value={user.id}
//                 >
//                   {user.name}
//                   {user.email
//                     ? ` (${user.email})`
//                     : ""}
//                 </option>
//               ))
//             )}
//           </select>
//         )}
//       </td>

//       {/* ACTION */}
//       <td className="px-4 py-4 align-top text-right">
//         {isPending(prestation) ? (
//           <button
//             type="button"
//             disabled={approvingId === id}
//             onClick={() =>
//               approvePrestation(id, prestation)
//             }
//             className="inline-flex items-center justify-center gap-2 rounded-lg bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground transition hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-50"
//           >
//             {approvingId === id ? (
//               <>
//                 <RefreshCw
//                   size={15}
//                   className="animate-spin"
//                 />
//                 Traitement...
//               </>
//             ) : (
//               <>
//                 <CheckCircle2 size={15} />
//                 Approuver
//               </>
//             )}
//           </button>
//         ) : (
//           <span className="text-xs text-muted-foreground">
//             —
//           </span>
//         )}
//       </td>
//     </tr>
//   );
// }

// /* =========================================================
//    TABLEAU
// ========================================================= */

// function PrestationTable({
//   prestations,
//   users,
//   assigned,
//   setAssigned,
//   approvePrestation,
//   approvingId,
//   emptyMessage,
// }) {
//   if (!prestations.length) {
//     return (
//       <div className="rounded-xl border border-dashed border-border p-8 text-center">
//         <CalendarDays
//           size={30}
//           className="mx-auto mb-3 text-muted-foreground"
//         />

//         <p className="font-medium">
//           {emptyMessage}
//         </p>

//         <p className="mt-1 text-sm text-muted-foreground">
//           Aucune prestation à afficher dans cette période.
//         </p>
//       </div>
//     );
//   }

//   return (
//     <div className="overflow-x-auto rounded-xl border border-border">
//       <table className="min-w-[1100px] w-full">
//         <thead className="bg-muted/70">
//           <tr>
//             <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-muted-foreground">
//               Prestation
//             </th>

//             <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-muted-foreground">
//               Institution
//             </th>

//             <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-muted-foreground">
//               Date & horaire
//             </th>

//             <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-muted-foreground">
//               Type
//             </th>

//             <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-muted-foreground">
//               Soignant
//             </th>

//             <th className="px-4 py-3 text-right text-xs font-semibold uppercase tracking-wide text-muted-foreground">
//               Action
//             </th>
//           </tr>
//         </thead>

//         <tbody>
//           {prestations.map((prestation) => (
//             <PrestationRow
//               key={getId(prestation)}
//               prestation={prestation}
//               users={users}
//               assigned={assigned}
//               setAssigned={setAssigned}
//               approvePrestation={approvePrestation}
//               approvingId={approvingId}
//             />
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// }

// /* =========================================================
//    PETIT GROUPE POUR UNE JOURNÉE
// ========================================================= */

// function DaySection({
//   date,
//   prestations,
//   users,
//   assigned,
//   setAssigned,
//   approvePrestation,
//   approvingId,
// }) {
//   const dayLabel = formatDayName(date);
//   const shortDate = formatShortDate(date);

//   return (
//     <div className="overflow-hidden rounded-xl border border-border">
//       <div className="flex items-center justify-between gap-3 bg-muted/50 px-4 py-3">
//         <div className="flex items-center gap-3">
//           <div className="rounded-lg bg-primary/10 p-2 text-primary">
//             <CalendarDays size={18} />
//           </div>

//           <div>
//             <p className="font-semibold capitalize">
//               {dayLabel}
//             </p>

//             <p className="text-xs text-muted-foreground">
//               {shortDate}
//             </p>
//           </div>
//         </div>

//         <span className="rounded-full bg-primary/10 px-3 py-1 text-xs font-semibold text-primary">
//           {prestations.length} prestation
//           {prestations.length !== 1 ? "s" : ""}
//         </span>
//       </div>

//       <div className="overflow-x-auto">
//         <table className="min-w-[1100px] w-full">
//           <thead className="bg-background">
//             <tr>
//               <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-muted-foreground">
//                 Prestation
//               </th>

//               <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-muted-foreground">
//                 Institution
//               </th>

//               <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-muted-foreground">
//                 Date & horaire
//               </th>

//               <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-muted-foreground">
//                 Type
//               </th>

//               <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-muted-foreground">
//                 Soignant
//               </th>

//               <th className="px-4 py-3 text-right text-xs font-semibold uppercase tracking-wide text-muted-foreground">
//                 Action
//               </th>
//             </tr>
//           </thead>

//           <tbody>
//             {prestations.map((prestation) => (
//               <PrestationRow
//                 key={getId(prestation)}
//                 prestation={prestation}
//                 users={users}
//                 assigned={assigned}
//                 setAssigned={setAssigned}
//                 approvePrestation={approvePrestation}
//                 approvingId={approvingId}
//               />
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// }

// /* =========================================================
//    PAGE ADMIN
// ========================================================= */

// export default function AdminPrestations() {
//   const { axiosInstance } = useAuth();

//   const [prestations, setPrestations] = useState([]);
//   const [pendingPrestations, setPendingPrestations] =
//     useState([]);

//   const [users, setUsers] = useState([]);

//   const [assigned, setAssigned] = useState({});

//   const [loading, setLoading] = useState(true);
//   const [refreshing, setRefreshing] = useState(false);
//   const [approvingId, setApprovingId] = useState(null);

//   /* =======================================================
//      CHARGEMENT
//   ======================================================= */

//   useEffect(() => {
//     loadData();
//   }, []);

//   const loadData = async () => {
//     try {
//       setLoading(true);

//       await Promise.all([
//         fetchPrestations(),
//         fetchPendingPrestations(),
//         fetchUsers(),
//       ]);
//     } catch (error) {
//       console.error(
//         "Erreur générale chargement dashboard :",
//         error
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   const refreshData = async () => {
//     try {
//       setRefreshing(true);

//       await Promise.all([
//         fetchPrestations(),
//         fetchPendingPrestations(),
//         fetchUsers(),
//       ]);

//       toast.success("Dashboard actualisé");
//     } catch (error) {
//       console.error(error);
//       toast.error(
//         "Erreur lors de l'actualisation"
//       );
//     } finally {
//       setRefreshing(false);
//     }
//   };

//   /* =======================================================
//      PRESTATIONS
//   ======================================================= */

//   const fetchPrestations = async () => {
//     try {
//       /*
//        * IMPORTANT :
//        * Cette route doit retourner les prestations visibles
//        * par l'administrateur.
//        *
//        * On récupère toutes les prestations retournées par
//        * le backend puis on limite l'affichage côté frontend
//        * aux périodes nécessaires.
//        */
//       const res = await axiosInstance.get(
//         "/prestations"
//       );

//       const data = getPrestationsArray(res.data);

//       console.log(
//         "ADMIN - prestations reçues :",
//         data.length,
//         data
//       );

//       setPrestations(data);
//     } catch (err) {
//       console.error(
//         "Erreur chargement prestations :",
//         err?.response?.data || err
//       );

//       setPrestations([]);
//     }
//   };

//   /* =======================================================
//      PRESTATIONS EN ATTENTE
//   ======================================================= */

//   const fetchPendingPrestations = async () => {
//     try {
//       const res = await axiosInstance.get(
//         "/prestations/pending"
//       );

//       const data = getPrestationsArray(res.data);

//       console.log(
//         "ADMIN - prestations pending reçues :",
//         data.length,
//         data
//       );

//       setPendingPrestations(data);
//     } catch (err) {
//       console.error(
//         "Erreur chargement prestations en attente :",
//         err?.response?.data || err
//       );

//       setPendingPrestations([]);
//     }
//   };

//   /* =======================================================
//      UTILISATEURS
//   ======================================================= */

//   const fetchUsers = async () => {
//     try {
//       const res = await axiosInstance.get("/users");

//       const rawUsers = Array.isArray(res.data)
//         ? res.data
//         : getPrestationsArray(res.data);

//       const filtered = rawUsers
//         .filter((user) => {
//           return (
//             !user.status ||
//             user.status === "approved"
//           );
//         })
//         .map((user) => {
//           const first = user.first_name
//             ? user.first_name.trim()
//             : "";

//           const last = user.last_name
//             ? user.last_name.trim()
//             : "";

//           const fullName =
//             `${first} ${last}`.trim();

//           return {
//             id: user.id || user._id,
//             role: user.role || "",
//             name:
//               fullName.length > 0
//                 ? fullName
//                 : user.name ||
//                   user.email ||
//                   "Utilisateur sans nom",
//             email: user.email || "",
//           };
//         })
//         .filter((user) => user.id);

//       setUsers(filtered);
//     } catch (err) {
//       console.error(
//         "Erreur chargement utilisateurs :",
//         err
//       );

//       toast.error(
//         "Erreur lors du chargement des utilisateurs"
//       );
//     }
//   };

//   /* =======================================================
//      FUSION
//   ======================================================= */

//   const allPrestations = useMemo(() => {
//     const map = new Map();

//     prestations.forEach((prestation) => {
//       const id = getId(prestation);

//       if (!id) return;

//       map.set(String(id), prestation);
//     });

//     pendingPrestations.forEach((prestation) => {
//       const id = getId(prestation);

//       if (!id) return;

//       const existing = map.get(
//         String(id)
//       );

//       map.set(String(id), {
//         ...(existing || {}),
//         ...prestation,
//       });
//     });

//     return Array.from(map.values());
//   }, [
//     prestations,
//     pendingPrestations,
//   ]);

//   /* =======================================================
//      AUJOURD'HUI
//   ======================================================= */

//   const prestationsDuJour = useMemo(() => {
//     return allPrestations
//       .filter((prestation) =>
//         isToday(prestation)
//       )
//       .sort((a, b) => {
//         const dateA = parseDate(
//           getStartDate(a)
//         );

//         const dateB = parseDate(
//           getStartDate(b)
//         );

//         return (
//           (dateA?.getTime() || 0) -
//           (dateB?.getTime() || 0)
//         );
//       });
//   }, [allPrestations]);

//   /* =======================================================
//      PROCHAINS 3 JOURS
//   ======================================================= */

//   const prestationsProchains3Jours =
//     useMemo(() => {
//       return allPrestations
//         .filter((prestation) =>
//           isWithinNextThreeDays(prestation)
//         )
//         .sort((a, b) => {
//           const dateA = parseDate(
//             getStartDate(a)
//           );

//           const dateB = parseDate(
//             getStartDate(b)
//           );

//           return (
//             (dateA?.getTime() || 0) -
//             (dateB?.getTime() || 0)
//           );
//         });
//     }, [allPrestations]);

//   /* =======================================================
//      GROUPEMENT PAR JOUR
//   ======================================================= */

//   const prestationsParJour =
//     useMemo(() => {
//       const groups = [];

//       const today = new Date();

//       for (let i = 1; i <= 3; i++) {
//         const targetDate = startOfDay(
//           addDays(today, i)
//         );

//         const prestationsJour =
//           prestationsProchains3Jours.filter(
//             (prestation) => {
//               const start = parseDate(
//                 getStartDate(prestation)
//               );

//               const end = parseDate(
//                 getEndDate(prestation)
//               );

//               if (!start) return false;

//               /*
//                * Prestation qui commence ce jour.
//                */
//               if (
//                 isSameDay(
//                   start,
//                   targetDate
//                 )
//               ) {
//                 return true;
//               }

//               /*
//                * Prestation longue qui couvre ce jour.
//                */
//               if (
//                 end &&
//                 start <= endOfDay(
//                   targetDate
//                 ) &&
//                 end >= startOfDay(
//                   targetDate
//                 )
//               ) {
//                 return true;
//               }

//               return false;
//             }
//           );

//         groups.push({
//           date: targetDate,
//           prestations: prestationsJour,
//         });
//       }

//       return groups;
//     }, [
//       prestationsProchains3Jours,
//     ]);

//   /* =======================================================
//      EN ATTENTE
//   ======================================================= */

//   const prestationsEnAttente =
//     useMemo(() => {
//       return allPrestations
//         .filter((prestation) =>
//           isPending(prestation)
//         )
//         .sort((a, b) => {
//           const dateA = parseDate(
//             getStartDate(a)
//           );

//           const dateB = parseDate(
//             getStartDate(b)
//           );

//           return (
//             (dateA?.getTime() || 0) -
//             (dateB?.getTime() || 0)
//           );
//         });
//     }, [allPrestations]);

//   /* =======================================================
//      COMPTEUR GLOBAL 3 JOURS
//   ======================================================= */

//   const nombreProchains3Jours =
//     prestationsProchains3Jours.length;

//   /* =======================================================
//      APPROBATION
//   ======================================================= */

//   const approvePrestation = async (
//     id,
//     prestation
//   ) => {
//     const assigned_to =
//       assigned[id];

//     if (
//       !assigned_to &&
//       !getAssignedName(prestation)
//     ) {
//       toast.error(
//         "Veuillez choisir un soignant avant d'approuver."
//       );

//       return;
//     }

//     try {
//       setApprovingId(id);

//       /*
//        * ASSIGNATION
//        */
//       if (!getAssignedName(prestation)) {
//         const selectedUser =
//           users.find(
//             (user) =>
//               String(user.id) ===
//               String(assigned_to)
//           );

//         await axiosInstance.put(
//           `/prestations/${id}/assign`,
//           {
//             assigned_to,
//             type_soignant:
//               prestation?.type_soignant ||
//               prestation?.typeSoignant ||
//               "nurse",
//             assigned_name:
//               selectedUser?.name ||
//               "Soignant",
//           }
//         );
//       }

//       /*
//        * APPROBATION
//        */
//       await axiosInstance.put(
//         `/prestations/${id}/approve`
//       );

//       toast.success(
//         "Prestation assignée et approuvée avec succès."
//       );

//       /*
//        * Nettoyage local.
//        */
//       setAssigned((previous) => {
//         const copy = {
//           ...previous,
//         };

//         delete copy[id];

//         return copy;
//       });

//       /*
//        * Recharge les données.
//        */
//       await Promise.all([
//         fetchPrestations(),
//         fetchPendingPrestations(),
//       ]);
//     } catch (err) {
//       console.error(
//         "Erreur assignation/approbation :",
//         err?.response?.data || err
//       );

//       const backendMessage =
//         err?.response?.data?.detail ||
//         err?.response?.data?.message;

//       toast.error(
//         backendMessage ||
//           "Erreur lors de l'assignation ou de l'approbation."
//       );
//     } finally {
//       setApprovingId(null);
//     }
//   };

//   /* =======================================================
//      LOADING
//   ======================================================= */

//   if (loading) {
//     return (
//       <Layout title="Dashboard administrateur">
//         <div className="flex min-h-[400px] items-center justify-center">
//           <div className="flex items-center gap-3 text-muted-foreground">
//             <RefreshCw
//               size={22}
//               className="animate-spin"
//             />

//             Chargement du dashboard...
//           </div>
//         </div>
//       </Layout>
//     );
//   }

//   /* =======================================================
//      RENDER
//   ======================================================= */

//   return (
//     <Layout title="Dashboard administrateur">
//       <div className="space-y-6">

//         {/* =================================================
//             HEADER
//         ================================================= */}

//         <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
//           <div>
//             <div className="flex items-center gap-2">
//               <h1 className="text-2xl font-bold tracking-tight">
//                 Vue d'ensemble
//               </h1>
//             </div>

//             <p className="mt-1 text-sm text-muted-foreground">
//               Suivez l'activité des prestations
//               de l'ensemble des établissements.
//             </p>
//           </div>

//           <button
//             type="button"
//             onClick={refreshData}
//             disabled={refreshing}
//             className="inline-flex items-center justify-center gap-2 rounded-lg border border-border bg-background px-4 py-2 text-sm font-medium transition hover:bg-muted disabled:cursor-not-allowed disabled:opacity-50"
//           >
//             <RefreshCw
//               size={16}
//               className={
//                 refreshing
//                   ? "animate-spin"
//                   : ""
//               }
//             />

//             Actualiser
//           </button>
//         </div>

//         {/* =================================================
//             STATISTIQUES
//         ================================================= */}

//         <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">

//           <StatCard
//             icon={CalendarDays}
//             title="Aujourd'hui"
//             value={
//               prestationsDuJour.length
//             }
//             description="Prestations prévues aujourd'hui"
//           />

//           <StatCard
//             icon={Clock}
//             title="3 prochains jours"
//             value={
//               nombreProchains3Jours
//             }
//             description="Prestations de demain à J+3"
//           />

//           <StatCard
//             icon={AlertCircle}
//             title="À traiter"
//             value={
//               prestationsEnAttente.length
//             }
//             description="Demandes en attente d'approbation"
//           />

//           <StatCard
//             icon={Users}
//             title="Soignants"
//             value={users.length}
//             description="Comptes soignants disponibles"
//           />

//         </div>

//         {/* =================================================
//             PRESTATIONS DU JOUR
//         ================================================= */}

//         <Card className="glass-card border-border">
//           <CardHeader>
//             <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">

//               <div>
//                 <CardTitle className="flex items-center gap-2">
//                   <CalendarDays
//                     size={20}
//                     className="text-primary"
//                   />

//                   Prestations du jour
//                 </CardTitle>

//                 <p className="mt-1 text-sm text-muted-foreground">
//                   Vue globale des prestations
//                   prévues aujourd'hui.
//                 </p>
//               </div>

//               <span className="w-fit rounded-full bg-primary/10 px-3 py-1 text-sm font-semibold text-primary">
//                 {prestationsDuJour.length} prestation
//                 {prestationsDuJour.length !== 1
//                   ? "s"
//                   : ""}
//               </span>

//             </div>
//           </CardHeader>

//           <CardContent>
//             <PrestationTable
//               prestations={
//                 prestationsDuJour
//               }
//               users={users}
//               assigned={assigned}
//               setAssigned={setAssigned}
//               approvePrestation={
//                 approvePrestation
//               }
//               approvingId={
//                 approvingId
//               }
//               emptyMessage="Aucune prestation aujourd'hui"
//             />
//           </CardContent>
//         </Card>

//         {/* =================================================
//             3 PROCHAINS JOURS
//         ================================================= */}

//         <Card className="glass-card border-border">
//           <CardHeader>
//             <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">

//               <div>
//                 <CardTitle className="flex items-center gap-2">
//                   <Clock
//                     size={20}
//                     className="text-primary"
//                   />

//                   Prochaines prestations
//                 </CardTitle>

//                 <p className="mt-1 text-sm text-muted-foreground">
//                   Planning des trois prochains
//                   jours.
//                 </p>
//               </div>

//               <span className="w-fit rounded-full bg-muted px-3 py-1 text-sm font-semibold">
//                 J+1 → J+3
//               </span>

//             </div>
//           </CardHeader>

//           <CardContent>
//             {nombreProchains3Jours === 0 ? (
//               <div className="rounded-xl border border-dashed border-border p-8 text-center">
//                 <Clock
//                   size={30}
//                   className="mx-auto mb-3 text-muted-foreground"
//                 />

//                 <p className="font-medium">
//                   Aucune prestation prévue
//                 </p>

//                 <p className="mt-1 text-sm text-muted-foreground">
//                   Aucune prestation n'est
//                   programmée dans les trois
//                   prochains jours.
//                 </p>
//               </div>
//             ) : (
//               <div className="space-y-4">
//                 {prestationsParJour.map(
//                   (group) => (
//                     <DaySection
//                       key={
//                         group.date.toISOString()
//                       }
//                       date={group.date}
//                       prestations={
//                         group.prestations
//                       }
//                       users={users}
//                       assigned={assigned}
//                       setAssigned={
//                         setAssigned
//                       }
//                       approvePrestation={
//                         approvePrestation
//                       }
//                       approvingId={
//                         approvingId
//                       }
//                     />
//                   )
//                 )}
//               </div>
//             )}
//           </CardContent>
//         </Card>

//         {/* =================================================
//             DEMANDES EN ATTENTE
//         ================================================= */}

//         <Card className="glass-card border-border">
//           <CardHeader>
//             <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">

//               <div>
//                 <CardTitle className="flex items-center gap-2">
//                   <AlertCircle
//                     size={20}
//                     className="text-amber-600"
//                   />

//                   Demandes à traiter
//                 </CardTitle>

//                 <p className="mt-1 text-sm text-muted-foreground">
//                   Prestations nécessitant une
//                   assignation et une approbation.
//                 </p>
//               </div>

//               <span className="w-fit rounded-full bg-amber-100 px-3 py-1 text-sm font-semibold text-amber-800">
//                 {prestationsEnAttente.length} en attente
//               </span>

//             </div>
//           </CardHeader>

//           <CardContent>
//             <PrestationTable
//               prestations={
//                 prestationsEnAttente
//               }
//               users={users}
//               assigned={assigned}
//               setAssigned={setAssigned}
//               approvePrestation={
//                 approvePrestation
//               }
//               approvingId={
//                 approvingId
//               }
//               emptyMessage="Aucune demande à traiter"
//             />
//           </CardContent>
//         </Card>

//       </div>
//     </Layout>
//   );
// }


import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../App";
import Layout from "../components/Layout";
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
} from "../components/ui/card";
import { toast } from "sonner";
import {
  CalendarDays,
  Clock,
  CheckCircle2,
  AlertCircle,
  Users,
  RefreshCw,
  ChevronRight,
  House,
} from "lucide-react";

/* =========================================================
   OUTILS
========================================================= */

function getPrestationsArray(data) {
  if (Array.isArray(data)) return data;

  if (Array.isArray(data?.prestations)) {
    return data.prestations;
  }

  if (Array.isArray(data?.items)) {
    return data.items;
  }

  if (Array.isArray(data?.data)) {
    return data.data;
  }

  if (Array.isArray(data?.results)) {
    return data.results;
  }

  return [];
}

function getId(item) {
  return item?.id || item?._id;
}

function getStartDate(prestation) {
  return (
    prestation?.dateStart ||
    prestation?.date_start ||
    prestation?.startDate ||
    prestation?.start_date ||
    prestation?.date ||
    prestation?.start ||
    null
  );
}

function getEndDate(prestation) {
  return (
    prestation?.dateEnd ||
    prestation?.date_end ||
    prestation?.endDate ||
    prestation?.end_date ||
    prestation?.end ||
    null
  );
}

function parseDate(value) {
  if (!value) return null;

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return null;
  }

  return date;
}

function startOfDay(date) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
}

function endOfDay(date) {
  const d = new Date(date);
  d.setHours(23, 59, 59, 999);
  return d;
}

function addDays(date, numberOfDays) {
  const d = new Date(date);
  d.setDate(d.getDate() + numberOfDays);
  return d;
}

function isSameDay(date1, date2) {
  if (!date1 || !date2) return false;

  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
}

/*
 * Une prestation appartient à aujourd'hui si :
 *
 * - elle commence aujourd'hui
 * OU
 * - elle a commencé avant aujourd'hui et se termine aujourd'hui
 * OU
 * - elle couvre toute la journée actuelle.
 */
function isToday(prestation) {
  const start = parseDate(getStartDate(prestation));
  const end = parseDate(getEndDate(prestation));

  if (!start) return false;

  const today = new Date();

  if (isSameDay(start, today)) {
    return true;
  }

  if (
    end &&
    start <= endOfDay(today) &&
    end >= startOfDay(today)
  ) {
    return true;
  }

  return false;
}

/*
 * Retourne true si la prestation commence entre demain
 * et J+3 inclus.
 *
 * IMPORTANT :
 * On ne montre donc PAS toutes les prestations futures.
 */
function isWithinNextThreeDays(prestation) {
  const start = parseDate(getStartDate(prestation));
  const end = parseDate(getEndDate(prestation));

  if (!start) return false;

  const today = new Date();

  const tomorrowStart = startOfDay(addDays(today, 1));
  const threeDaysEnd = endOfDay(addDays(today, 3));

  /*
   * Cas normal :
   * la prestation commence entre demain et J+3.
   */
  if (
    start >= tomorrowStart &&
    start <= threeDaysEnd
  ) {
    return true;
  }

  /*
   * Cas d'une prestation qui a commencé avant demain
   * mais qui continue sur une des 3 journées à venir.
   */
  if (
    end &&
    start < tomorrowStart &&
    end >= tomorrowStart &&
    start <= threeDaysEnd
  ) {
    return true;
  }

  return false;
}

/*
 * Vérifie si la prestation est réellement future.
 */
function isFuture(prestation) {
  const start = parseDate(getStartDate(prestation));

  if (!start) return false;

  return start > new Date();
}

function formatDate(value) {
  const date = parseDate(value);

  if (!date) return "-";

  return date.toLocaleDateString("fr-BE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

function formatDayName(date) {
  if (!date) return "";

  return date.toLocaleDateString("fr-BE", {
    weekday: "long",
  });
}

function formatShortDate(date) {
  if (!date) return "";

  return date.toLocaleDateString("fr-BE", {
    day: "2-digit",
    month: "2-digit",
  });
}

function formatTime(value) {
  const date = parseDate(value);

  if (!date) return "-";

  return date.toLocaleTimeString("fr-BE", {
    hour: "2-digit",
    minute: "2-digit",
  });
}

function getInstitutionName(prestation) {
  return (
    prestation?.institution_name ||
    prestation?.institutionName ||
    prestation?.institution?.name ||
    prestation?.institution?.institution_name ||
    prestation?.institution ||
    "-"
  );
}

function getSoignantType(prestation) {
  return (
    prestation?.type_soignant ||
    prestation?.typeSoignant ||
    prestation?.soignant_type ||
    prestation?.soignantType ||
    prestation?.role ||
    ""
  );
}

function getAssignedName(prestation) {
  return (
    prestation?.assigned_name ||
    prestation?.assignedName ||
    prestation?.soignant_name ||
    prestation?.soignantName ||
    prestation?.assigned_to_name ||
    prestation?.assignedToName ||
    null
  );
}

function getStatus(prestation) {
  return (
    prestation?.status ||
    prestation?.state ||
    prestation?.statut ||
    ""
  )
    .toString()
    .toLowerCase()
    .trim();
}

function isPending(prestation) {
  const status = getStatus(prestation);

  return (
    status === "pending" ||
    status === "en_attente" ||
    status === "en attente" ||
    status === "waiting" ||
    status === "requested" ||
    status === "request"
  );
}

function getPrestataireLabel(type) {
  if (!type) return "Soignant";

  const value = type.toString().toLowerCase();

  if (
    value.includes("nurse") ||
    value.includes("infirm") ||
    value === "infirmier" ||
    value === "infirmière"
  ) {
    return "Infirmier";
  }

  if (
    value.includes("caregiver") ||
    value.includes("aide") ||
    value.includes("soignant") ||
    value === "as"
  ) {
    return "Aide-soignant";
  }

  return type;
}

/* =========================================================
   BADGE STATUT
========================================================= */

function StatusBadge({ prestation }) {
  const assignedName = getAssignedName(prestation);
  const pending = isPending(prestation);

  if (pending) {
    return (
      <span className="inline-flex items-center gap-1.5 rounded-full bg-amber-100 px-3 py-1 text-xs font-semibold text-amber-800">
        <AlertCircle size={13} />
        En attente
      </span>
    );
  }

  if (assignedName) {
    return (
      <span className="inline-flex items-center gap-1.5 rounded-full bg-emerald-100 px-3 py-1 text-xs font-semibold text-emerald-800">
        <CheckCircle2 size={13} />
        Assignée
      </span>
    );
  }

  return (
    <span className="inline-flex items-center gap-1.5 rounded-full bg-muted px-3 py-1 text-xs font-semibold text-muted-foreground">
      Disponible
    </span>
  );
}

/* =========================================================
   CARTE STATISTIQUE
========================================================= */

function StatCard({
  icon: Icon,
  title,
  value,
  description,
}) {
  return (
    <Card className="glass-card border-border">
      <CardContent className="p-5">
        <div className="flex items-start justify-between gap-4">
          <div>
            <p className="text-sm font-medium text-muted-foreground">
              {title}
            </p>

            <p className="mt-2 text-3xl font-bold tracking-tight">
              {value}
            </p>

            <p className="mt-1 text-xs text-muted-foreground">
              {description}
            </p>
          </div>

          <div className="rounded-xl bg-primary/10 p-3 text-primary">
            <Icon size={22} />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

/* =========================================================
   LIGNE PRESTATION
========================================================= */

function PrestationRow({
  prestation,
  users,
  assigned,
  setAssigned,
  approvePrestation,
  approvingId,
  showDate = true,
}) {
  const id = getId(prestation);

  const start = getStartDate(prestation);
  const end = getEndDate(prestation);

  const type = getSoignantType(prestation);

  const matchingUsers = users.filter((user) => {
    if (!type) return true;

    const wanted = type.toString().toLowerCase();
    const role = (user.role || "").toString().toLowerCase();

    if (wanted === role) {
      return true;
    }

    if (
      wanted.includes("nurse") ||
      wanted.includes("infirm")
    ) {
      return (
        role.includes("nurse") ||
        role.includes("infirm")
      );
    }

    if (
      wanted.includes("caregiver") ||
      wanted.includes("aide") ||
      wanted.includes("soignant") ||
      wanted === "as"
    ) {
      return (
        role.includes("caregiver") ||
        role.includes("aide") ||
        role === "as" ||
        role.includes("soignant")
      );
    }

    return false;
  });

  return (
    <tr className="border-t border-border/70 transition-colors hover:bg-muted/40">
      {/* PRESTATION */}
      <td className="px-4 py-4 align-top">
        <div className="font-semibold">
          {prestation?.name ||
            prestation?.title ||
            "Prestation"}
        </div>

        {prestation?.description && (
          <div className="mt-1 max-w-xs text-xs text-muted-foreground line-clamp-2">
            {prestation.description}
          </div>
        )}
      </td>

      {/* INSTITUTION */}
      <td className="px-4 py-4 align-top">
        <div className="font-medium">
          {getInstitutionName(prestation)}
        </div>
      </td>

      {/* DATE */}
      {showDate && (
        <td className="px-4 py-4 align-top">
          <div className="flex items-center gap-2">
            <CalendarDays
              size={15}
              className="text-primary"
            />

            <span>
              {formatDate(start)}
            </span>
          </div>

          <div className="mt-1 flex items-center gap-2 text-xs text-muted-foreground">
            <Clock size={13} />

            <span>
              {formatTime(start)}

              {end
                ? ` → ${formatTime(end)}`
                : ""}
            </span>
          </div>
        </td>
      )}

      {/* TYPE */}
      <td className="px-4 py-4 align-top">
        <div className="flex flex-col gap-2">
          <span className="text-sm font-medium">
            {getPrestataireLabel(type)}
          </span>

          <StatusBadge prestation={prestation} />
        </div>
      </td>

      {/* SOIGNANT */}
      <td className="px-4 py-4 align-top">
        {getAssignedName(prestation) ? (
          <div className="flex items-center gap-2 text-sm">
            <Users
              size={15}
              className="text-muted-foreground"
            />

            <span>
              {getAssignedName(prestation)}
            </span>
          </div>
        ) : (
          <select
            value={assigned[id] || ""}
            onChange={(e) =>
              setAssigned((prev) => ({
                ...prev,
                [id]: e.target.value,
              }))
            }
            className="w-full min-w-[210px] rounded-lg border border-border bg-background px-3 py-2 text-sm outline-none transition focus:ring-2 focus:ring-primary/30"
          >
            <option value="">
              -- Choisir un soignant --
            </option>

            {matchingUsers.length === 0 ? (
              <option value="" disabled>
                Aucun utilisateur compatible
              </option>
            ) : (
              matchingUsers.map((user) => (
                <option
                  key={user.id}
                  value={user.id}
                >
                  {user.name}
                  {user.email
                    ? ` (${user.email})`
                    : ""}
                </option>
              ))
            )}
          </select>
        )}
      </td>

      {/* ACTION */}
      <td className="px-4 py-4 align-top text-right">
        {isPending(prestation) ? (
          <button
            type="button"
            disabled={approvingId === id}
            onClick={() =>
              approvePrestation(id, prestation)
            }
            className="inline-flex items-center justify-center gap-2 rounded-lg bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground transition hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {approvingId === id ? (
              <>
                <RefreshCw
                  size={15}
                  className="animate-spin"
                />
                Traitement...
              </>
            ) : (
              <>
                <CheckCircle2 size={15} />
                Approuver
              </>
            )}
          </button>
        ) : (
          <span className="text-xs text-muted-foreground">
            —
          </span>
        )}
      </td>
    </tr>
  );
}

/* =========================================================
   TABLEAU
========================================================= */

function PrestationTable({
  prestations,
  users,
  assigned,
  setAssigned,
  approvePrestation,
  approvingId,
  emptyMessage,
}) {
  if (!prestations.length) {
    return (
      <div className="rounded-xl border border-dashed border-border p-8 text-center">
        <CalendarDays
          size={30}
          className="mx-auto mb-3 text-muted-foreground"
        />

        <p className="font-medium">
          {emptyMessage}
        </p>

        <p className="mt-1 text-sm text-muted-foreground">
          Aucune prestation à afficher dans cette période.
        </p>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto rounded-xl border border-border">
      <table className="min-w-[1100px] w-full">
        <thead className="bg-muted/70">
          <tr>
            <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-muted-foreground">
              Prestation
            </th>

            <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-muted-foreground">
              Institution
            </th>

            <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-muted-foreground">
              Date & horaire
            </th>

            <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-muted-foreground">
              Type
            </th>

            <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-muted-foreground">
              Soignant
            </th>

            <th className="px-4 py-3 text-right text-xs font-semibold uppercase tracking-wide text-muted-foreground">
              Action
            </th>
          </tr>
        </thead>

        <tbody>
          {prestations.map((prestation) => (
            <PrestationRow
              key={getId(prestation)}
              prestation={prestation}
              users={users}
              assigned={assigned}
              setAssigned={setAssigned}
              approvePrestation={approvePrestation}
              approvingId={approvingId}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}

/* =========================================================
   PETIT GROUPE POUR UNE JOURNÉE
========================================================= */

function DaySection({
  date,
  prestations,
  users,
  assigned,
  setAssigned,
  approvePrestation,
  approvingId,
}) {
  const dayLabel = formatDayName(date);
  const shortDate = formatShortDate(date);

  return (
    <div className="overflow-hidden rounded-xl border border-border">
      <div className="flex items-center justify-between gap-3 bg-muted/50 px-4 py-3">
        <div className="flex items-center gap-3">
          <div className="rounded-lg bg-primary/10 p-2 text-primary">
            <CalendarDays size={18} />
          </div>

          <div>
            <p className="font-semibold capitalize">
              {dayLabel}
            </p>

            <p className="text-xs text-muted-foreground">
              {shortDate}
            </p>
          </div>
        </div>

        <span className="rounded-full bg-primary/10 px-3 py-1 text-xs font-semibold text-primary">
          {prestations.length} prestation
          {prestations.length !== 1 ? "s" : ""}
        </span>
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-[1100px] w-full">
          <thead className="bg-background">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-muted-foreground">
                Prestation
              </th>

              <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-muted-foreground">
                Institution
              </th>

              <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-muted-foreground">
                Date & horaire
              </th>

              <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-muted-foreground">
                Type
              </th>

              <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-muted-foreground">
                Soignant
              </th>

              <th className="px-4 py-3 text-right text-xs font-semibold uppercase tracking-wide text-muted-foreground">
                Action
              </th>
            </tr>
          </thead>

          <tbody>
            {prestations.map((prestation) => (
              <PrestationRow
                key={getId(prestation)}
                prestation={prestation}
                users={users}
                assigned={assigned}
                setAssigned={setAssigned}
                approvePrestation={approvePrestation}
                approvingId={approvingId}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

/* =========================================================
   PAGE ADMIN
========================================================= */

export default function AdminPrestations() {
  const { axiosInstance } = useAuth();

  const [prestations, setPrestations] = useState([]);
  const [pendingPrestations, setPendingPrestations] =
    useState([]);

  const [users, setUsers] = useState([]);
  const [remplacementsDomicile, setRemplacementsDomicile] = useState([]);

  const [assigned, setAssigned] = useState({});

  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [approvingId, setApprovingId] = useState(null);

  /* =======================================================
     CHARGEMENT
  ======================================================= */

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);

      await Promise.all([
        fetchPrestations(),
        fetchPendingPrestations(),
        fetchUsers(),
        fetchRemplacementsDomicile(),
      ]);
    } catch (error) {
      console.error(
        "Erreur générale chargement dashboard :",
        error
      );
    } finally {
      setLoading(false);
    }
  };

  const refreshData = async () => {
    try {
      setRefreshing(true);

      await Promise.all([
        fetchPrestations(),
        fetchPendingPrestations(),
        fetchUsers(),
        fetchRemplacementsDomicile(),
      ]);

      toast.success("Dashboard actualisé");
    } catch (error) {
      console.error(error);
      toast.error(
        "Erreur lors de l'actualisation"
      );
    } finally {
      setRefreshing(false);
    }
  };

  /* =======================================================
     PRESTATIONS
  ======================================================= */

  const fetchPrestations = async () => {
    try {
      /*
       * IMPORTANT :
       * Cette route doit retourner les prestations visibles
       * par l'administrateur.
       *
       * On récupère toutes les prestations retournées par
       * le backend puis on limite l'affichage côté frontend
       * aux périodes nécessaires.
       */
      const res = await axiosInstance.get(
        "/prestations"
      );

      const data = getPrestationsArray(res.data);

      console.log(
        "ADMIN - prestations reçues :",
        data.length,
        data
      );

      setPrestations(data);
    } catch (err) {
      console.error(
        "Erreur chargement prestations :",
        err?.response?.data || err
      );

      setPrestations([]);
    }
  };

  /* =======================================================
     PRESTATIONS EN ATTENTE
  ======================================================= */

  const fetchPendingPrestations = async () => {
    try {
      const res = await axiosInstance.get(
        "/prestations/pending"
      );

      const data = getPrestationsArray(res.data);

      console.log(
        "ADMIN - prestations pending reçues :",
        data.length,
        data
      );

      setPendingPrestations(data);
    } catch (err) {
      console.error(
        "Erreur chargement prestations en attente :",
        err?.response?.data || err
      );

      setPendingPrestations([]);
    }
  };

  /* =======================================================
     UTILISATEURS
  ======================================================= */

  const fetchUsers = async () => {
    try {
      const res = await axiosInstance.get("/users");

      const rawUsers = Array.isArray(res.data)
        ? res.data
        : getPrestationsArray(res.data);

      const filtered = rawUsers
        .filter((user) => {
          return (
            !user.status ||
            user.status === "approved"
          );
        })
        .map((user) => {
          const first = user.first_name
            ? user.first_name.trim()
            : "";

          const last = user.last_name
            ? user.last_name.trim()
            : "";

          const fullName =
            `${first} ${last}`.trim();

          return {
            id: user.id || user._id,
            role: user.role || "",
            name:
              fullName.length > 0
                ? fullName
                : user.name ||
                  user.email ||
                  "Utilisateur sans nom",
            email: user.email || "",
          };
        })
        .filter((user) => user.id);

      setUsers(filtered);
    } catch (err) {
      console.error(
        "Erreur chargement utilisateurs :",
        err
      );

      toast.error(
        "Erreur lors du chargement des utilisateurs"
      );
    }
  };


  /* =======================================================
     REMPLACEMENTS DOMICILE
  ======================================================= */

  const fetchRemplacementsDomicile = async () => {
    try {
      const res = await axiosInstance.get(
        "/remplacements-domicile/admin"
      );

      setRemplacementsDomicile(
        Array.isArray(res.data) ? res.data : []
      );
    } catch (err) {
      console.error(
        "Erreur chargement remplacements domicile :",
        err?.response?.data || err
      );

      setRemplacementsDomicile([]);
    }
  };

  /* =======================================================
     FUSION
  ======================================================= */

  const allPrestations = useMemo(() => {
    const map = new Map();

    prestations.forEach((prestation) => {
      const id = getId(prestation);

      if (!id) return;

      map.set(String(id), prestation);
    });

    pendingPrestations.forEach((prestation) => {
      const id = getId(prestation);

      if (!id) return;

      const existing = map.get(
        String(id)
      );

      map.set(String(id), {
        ...(existing || {}),
        ...prestation,
      });
    });

    return Array.from(map.values());
  }, [
    prestations,
    pendingPrestations,
  ]);

  /* =======================================================
     AUJOURD'HUI
  ======================================================= */

  const prestationsDuJour = useMemo(() => {
    return allPrestations
      .filter((prestation) =>
        isToday(prestation)
      )
      .sort((a, b) => {
        const dateA = parseDate(
          getStartDate(a)
        );

        const dateB = parseDate(
          getStartDate(b)
        );

        return (
          (dateA?.getTime() || 0) -
          (dateB?.getTime() || 0)
        );
      });
  }, [allPrestations]);

  /* =======================================================
     PROCHAINS 3 JOURS
  ======================================================= */

  const prestationsProchains3Jours =
    useMemo(() => {
      return allPrestations
        .filter((prestation) =>
          isWithinNextThreeDays(prestation)
        )
        .sort((a, b) => {
          const dateA = parseDate(
            getStartDate(a)
          );

          const dateB = parseDate(
            getStartDate(b)
          );

          return (
            (dateA?.getTime() || 0) -
            (dateB?.getTime() || 0)
          );
        });
    }, [allPrestations]);

  /* =======================================================
     GROUPEMENT PAR JOUR
  ======================================================= */

  const prestationsParJour =
    useMemo(() => {
      const groups = [];

      const today = new Date();

      for (let i = 1; i <= 3; i++) {
        const targetDate = startOfDay(
          addDays(today, i)
        );

        const prestationsJour =
          prestationsProchains3Jours.filter(
            (prestation) => {
              const start = parseDate(
                getStartDate(prestation)
              );

              const end = parseDate(
                getEndDate(prestation)
              );

              if (!start) return false;

              /*
               * Prestation qui commence ce jour.
               */
              if (
                isSameDay(
                  start,
                  targetDate
                )
              ) {
                return true;
              }

              /*
               * Prestation longue qui couvre ce jour.
               */
              if (
                end &&
                start <= endOfDay(
                  targetDate
                ) &&
                end >= startOfDay(
                  targetDate
                )
              ) {
                return true;
              }

              return false;
            }
          );

        groups.push({
          date: targetDate,
          prestations: prestationsJour,
        });
      }

      return groups;
    }, [
      prestationsProchains3Jours,
    ]);

  /* =======================================================
     EN ATTENTE
  ======================================================= */

  const prestationsEnAttente =
    useMemo(() => {
      return allPrestations
        .filter((prestation) =>
          isPending(prestation)
        )
        .sort((a, b) => {
          const dateA = parseDate(
            getStartDate(a)
          );

          const dateB = parseDate(
            getStartDate(b)
          );

          return (
            (dateA?.getTime() || 0) -
            (dateB?.getTime() || 0)
          );
        });
    }, [allPrestations]);

  const remplacementsATraiter = useMemo(() => {
    return remplacementsDomicile.filter((item) =>
      [
        "nouvelle",
        "a_analyser",
        "acceptee",
        "soignant_a_attribuer",
      ].includes(item?.statut)
    );
  }, [remplacementsDomicile]);

  /* =======================================================
     COMPTEUR GLOBAL 3 JOURS
  ======================================================= */

  const nombreProchains3Jours =
    prestationsProchains3Jours.length;

  /* =======================================================
     APPROBATION
  ======================================================= */

  const approvePrestation = async (
    id,
    prestation
  ) => {
    const assigned_to =
      assigned[id];

    if (
      !assigned_to &&
      !getAssignedName(prestation)
    ) {
      toast.error(
        "Veuillez choisir un soignant avant d'approuver."
      );

      return;
    }

    try {
      setApprovingId(id);

      /*
       * ASSIGNATION
       */
      if (!getAssignedName(prestation)) {
        const selectedUser =
          users.find(
            (user) =>
              String(user.id) ===
              String(assigned_to)
          );

        await axiosInstance.put(
          `/prestations/${id}/assign`,
          {
            assigned_to,
            type_soignant:
              prestation?.type_soignant ||
              prestation?.typeSoignant ||
              "nurse",
            assigned_name:
              selectedUser?.name ||
              "Soignant",
          }
        );
      }

      /*
       * APPROBATION
       */
      await axiosInstance.put(
        `/prestations/${id}/approve`
      );

      toast.success(
        "Prestation assignée et approuvée avec succès."
      );

      /*
       * Nettoyage local.
       */
      setAssigned((previous) => {
        const copy = {
          ...previous,
        };

        delete copy[id];

        return copy;
      });

      /*
       * Recharge les données.
       */
      await Promise.all([
        fetchPrestations(),
        fetchPendingPrestations(),
      ]);
    } catch (err) {
      console.error(
        "Erreur assignation/approbation :",
        err?.response?.data || err
      );

      const backendMessage =
        err?.response?.data?.detail ||
        err?.response?.data?.message;

      toast.error(
        backendMessage ||
          "Erreur lors de l'assignation ou de l'approbation."
      );
    } finally {
      setApprovingId(null);
    }
  };

  /* =======================================================
     LOADING
  ======================================================= */

  if (loading) {
    return (
      <Layout title="Dashboard administrateur">
        <div className="flex min-h-[400px] items-center justify-center">
          <div className="flex items-center gap-3 text-muted-foreground">
            <RefreshCw
              size={22}
              className="animate-spin"
            />

            Chargement du dashboard...
          </div>
        </div>
      </Layout>
    );
  }

  /* =======================================================
     RENDER
  ======================================================= */

  return (
    <Layout title="Dashboard administrateur">
      <div className="space-y-6">

        {/* =================================================
            HEADER
        ================================================= */}

        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          <div>
            <div className="flex items-center gap-2">
              <h1 className="text-2xl font-bold tracking-tight">
                Vue d'ensemble
              </h1>
            </div>

            <p className="mt-1 text-sm text-muted-foreground">
              Suivez l'activité des prestations
              de l'ensemble des établissements.
            </p>
          </div>

          <button
            type="button"
            onClick={refreshData}
            disabled={refreshing}
            className="inline-flex items-center justify-center gap-2 rounded-lg border border-border bg-background px-4 py-2 text-sm font-medium transition hover:bg-muted disabled:cursor-not-allowed disabled:opacity-50"
          >
            <RefreshCw
              size={16}
              className={
                refreshing
                  ? "animate-spin"
                  : ""
              }
            />

            Actualiser
          </button>
        </div>

        {/* =================================================
            STATISTIQUES
        ================================================= */}

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-5">

          <StatCard
            icon={CalendarDays}
            title="Aujourd'hui"
            value={
              prestationsDuJour.length
            }
            description="Prestations prévues aujourd'hui"
          />

          <StatCard
            icon={Clock}
            title="3 prochains jours"
            value={
              nombreProchains3Jours
            }
            description="Prestations de demain à J+3"
          />

          <StatCard
            icon={AlertCircle}
            title="À traiter"
            value={
              prestationsEnAttente.length
            }
            description="Demandes en attente d'approbation"
          />

          <StatCard
            icon={Users}
            title="Soignants"
            value={users.length}
            description="Comptes soignants disponibles"
          />

          <StatCard
            icon={House}
            title="Remplacements domicile"
            value={remplacementsATraiter.length}
            description="Demandes de titulaires à traiter"
          />

        </div>

        <div className="flex justify-end">
          <Link
            to="/remplacements-domicile-admin"
            className="inline-flex items-center gap-2 rounded-lg bg-[#6faeb2] px-4 py-2 text-sm font-semibold text-white transition hover:bg-[#5b979b]"
          >
            <House size={16} />
            Gérer les remplacements domicile
            <ChevronRight size={16} />
          </Link>
        </div>

        {/* =================================================
            PRESTATIONS DU JOUR
        ================================================= */}

        <Card className="glass-card border-border">
          <CardHeader>
            <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">

              <div>
                <CardTitle className="flex items-center gap-2">
                  <CalendarDays
                    size={20}
                    className="text-primary"
                  />

                  Prestations du jour
                </CardTitle>

                <p className="mt-1 text-sm text-muted-foreground">
                  Vue globale des prestations
                  prévues aujourd'hui.
                </p>
              </div>

              <span className="w-fit rounded-full bg-primary/10 px-3 py-1 text-sm font-semibold text-primary">
                {prestationsDuJour.length} prestation
                {prestationsDuJour.length !== 1
                  ? "s"
                  : ""}
              </span>

            </div>
          </CardHeader>

          <CardContent>
            <PrestationTable
              prestations={
                prestationsDuJour
              }
              users={users}
              assigned={assigned}
              setAssigned={setAssigned}
              approvePrestation={
                approvePrestation
              }
              approvingId={
                approvingId
              }
              emptyMessage="Aucune prestation aujourd'hui"
            />
          </CardContent>
        </Card>

        {/* =================================================
            3 PROCHAINS JOURS
        ================================================= */}

        <Card className="glass-card border-border">
          <CardHeader>
            <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">

              <div>
                <CardTitle className="flex items-center gap-2">
                  <Clock
                    size={20}
                    className="text-primary"
                  />

                  Prochaines prestations
                </CardTitle>

                <p className="mt-1 text-sm text-muted-foreground">
                  Planning des trois prochains
                  jours.
                </p>
              </div>

              <span className="w-fit rounded-full bg-muted px-3 py-1 text-sm font-semibold">
                J+1 → J+3
              </span>

            </div>
          </CardHeader>

          <CardContent>
            {nombreProchains3Jours === 0 ? (
              <div className="rounded-xl border border-dashed border-border p-8 text-center">
                <Clock
                  size={30}
                  className="mx-auto mb-3 text-muted-foreground"
                />

                <p className="font-medium">
                  Aucune prestation prévue
                </p>

                <p className="mt-1 text-sm text-muted-foreground">
                  Aucune prestation n'est
                  programmée dans les trois
                  prochains jours.
                </p>
              </div>
            ) : (
              <div className="space-y-4">
                {prestationsParJour.map(
                  (group) => (
                    <DaySection
                      key={
                        group.date.toISOString()
                      }
                      date={group.date}
                      prestations={
                        group.prestations
                      }
                      users={users}
                      assigned={assigned}
                      setAssigned={
                        setAssigned
                      }
                      approvePrestation={
                        approvePrestation
                      }
                      approvingId={
                        approvingId
                      }
                    />
                  )
                )}
              </div>
            )}
          </CardContent>
        </Card>

        {/* =================================================
            DEMANDES EN ATTENTE
        ================================================= */}

        <Card className="glass-card border-border">
          <CardHeader>
            <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">

              <div>
                <CardTitle className="flex items-center gap-2">
                  <AlertCircle
                    size={20}
                    className="text-amber-600"
                  />

                  Demandes à traiter
                </CardTitle>

                <p className="mt-1 text-sm text-muted-foreground">
                  Prestations nécessitant une
                  assignation et une approbation.
                </p>
              </div>

              <span className="w-fit rounded-full bg-amber-100 px-3 py-1 text-sm font-semibold text-amber-800">
                {prestationsEnAttente.length} en attente
              </span>

            </div>
          </CardHeader>

          <CardContent>
            <PrestationTable
              prestations={
                prestationsEnAttente
              }
              users={users}
              assigned={assigned}
              setAssigned={setAssigned}
              approvePrestation={
                approvePrestation
              }
              approvingId={
                approvingId
              }
              emptyMessage="Aucune demande à traiter"
            />
          </CardContent>
        </Card>

      </div>
    </Layout>
  );
}

